<template>
	<div class="explanation-container display-flex flex-align-center flex-row py-1">
		<SIcon name="create-and-manage-tabs-explanation" class="mr-2" />
		<slot />
		<SIcon @click.native="$emit('dismiss')" name="dismiss-tabs-explanation" class="dismiss-button" />
	</div>
</template>
<script>
export default { name: 'ProjectMenuTabsExplanation' };
</script>
<style scoped lang="scss">
.explanation-container {
	border-radius: 5px;
	border: 1px solid #e2e7f0;
	background: var(--sub-title-background);
}
.dismiss-button {
	top: -38px;
	right: -9px;
	cursor: pointer;
	position: relative;
}
</style>
